let slider = document.querySelector('.c-cross-sell__body-container');
let isDown = false;
let startX;
let scrollLeft;

function sliderMouseDown(e) {
  isDown = true;
  slider.classList.add('active');
  startX = e.pageX - slider.offsetLeft;
  scrollLeft = slider.scrollLeft;
}

function sliderMouseLeave() {
  isDown = false;
  slider.classList.remove('active');
}

function sliderMouseUp() {
  isDown = false;
  slider.classList.remove('active');
}

function sliderMouseMove(e) {
  if(!isDown) return;
  e.preventDefault();
  const x = e.pageX - slider.offsetLeft;
  const walk = (x - startX);
  slider.scrollLeft = scrollLeft - walk;
}

function sliderLeftBtn() {
  const collection = document.querySelectorAll(".c-cross-sell__body-container .c-cart-line");
  let lastLeft = 0;
  for (let i = 0; i < collection.length; i++) {
    if (collection[i].getBoundingClientRect().left < slider.getBoundingClientRect().left) {
      lastLeft = collection[i].getBoundingClientRect().left - slider.getBoundingClientRect().left + slider.scrollLeft
    }
  }

  slider.scrollTo({
    left: lastLeft,
    behavior: "smooth",
  });
}

function sliderRightBtn() {
  const collection = document.querySelectorAll(".c-cross-sell__body-container .c-cart-line");
  let lastLeft = 0;
  for (let i = 0; i < collection.length; i++) {
    if (collection[i].getBoundingClientRect().left-1 < slider.getBoundingClientRect().left) {
      lastLeft = collection[i+1].getBoundingClientRect().left - slider.getBoundingClientRect().left + slider.scrollLeft
    }
  }

  slider.scrollTo({
    left: lastLeft,
    behavior: "smooth",
  });
}

function addSlider() {
    slider = document.querySelector('.c-cross-sell__body-container');

    if (slider) {
      slider.addEventListener('mousedown', sliderMouseDown);
      slider.addEventListener('mouseleave', sliderMouseLeave);
      slider.addEventListener('mouseup', sliderMouseUp);
      slider.addEventListener('mousemove', sliderMouseMove);
      if (document.querySelectorAll('.c-cross-sell__body-container .c-cart-line').length > 1 && document.querySelector('#cart_upsell_left_btn') == undefined) {
        document.querySelector('.c-cross-sell__body-container').innerHTML += '<button type="button" id="cart_upsell_left_btn" class="card_upsel_direction_btn">&lt;</button><button type="button" id="cart_upsell_right_btn" class="card_upsel_direction_btn">&gt;</button>'
      }
      if (document.querySelectorAll('.c-cross-sell__body-container .c-cart-line').length > 1) {
        document.querySelector('#cart_upsell_left_btn').addEventListener("click", sliderLeftBtn);
        document.querySelector('#cart_upsell_right_btn').addEventListener("click", sliderRightBtn);
      }
    }
}

// it is very dificult to get at the events that add and remove the slider so this will catch all scenarios
setInterval(function(){
  addSlider()
},1000)

document.addEventListener('DOMContentLoaded', function() {

  document.querySelectorAll('.c-desktop-menu__search-popup-trigger').forEach(trigger => {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      document.documentElement.classList.toggle('search-popup-is-open');
      document.body.classList.toggle('search-popup-is-open');
      if (!document.body.classList.contains('search-popup-is-open')) {
        document.body.classList.remove('ss__autocomplete--active');
        setTimeout(function() {
          document.body.focus();
        }, 100)
      } else {
        document.getElementById('search__text').focus();
      }
    });
  });
  
  const rewards_tooltip = document.querySelector('.c-product-rewards-cta__block-tooltip');
  const rewards_tooltip_trigger = document.querySelector('.c-product-rewards-cta__block-tooltip-trigger');
  
  if (rewards_tooltip) {
    // Function to toggle the 'active' class on click
    rewards_tooltip_trigger.addEventListener('click', function(event) {
      event.stopPropagation();
      rewards_tooltip.classList.toggle('active');
    });
    
    // Remove 'active' class when clicking outside the tooltip container
    document.addEventListener('click', function(event) {
      if (!rewards_tooltip.contains(event.target)) {
        rewards_tooltip.classList.remove('active');
      }
    });
  }
})

setTimeout(function(){
  // update all product variant selectors when one is updated
  const swatchPickers = document.getElementsByClassName('o-swatches__swatch-select')
  for (const sp of swatchPickers) {
    if (sp.dataset.swatchOptionName == 'Size') {
      sp.onchange = function(e) {
        const dd = document.getElementsByClassName('select2-selection__rendered')[0].textContent = e.target.value
        for (const sp2 of swatchPickers) {
          sp2.value = e.target.value;
        }
      }
    }
  }
  
},1000)

